import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from 'react';

import axios from 'axios';
import ApiClient from '../../api/client';

import { useMutation, useQuery, useQueryClient } from 'react-query';
import { fetcher } from '../../api/client';
import { toast } from 'react-toastify';
import MainLayout from '../../layouts/MainLayout';
import { useParams, Link, useHistory } from 'react-router-dom';
import { useStripe } from '@stripe/react-stripe-js';
import { useTranslation } from 'react-i18next';
import { useAuthState } from '../../context/auth';
import SectionChild from './sectionChild';
import '../../scss/newEditor/newEditos.scss';
import useQueryParams from '../../hooks/useQuery';
import { EditorDocumentPreview } from '../../components/DocumentPreview';
import EditorElement from '../DocumentPreview/TratoFormat/Elements/newEditorElement';
import EditTemplateConfiguration from '../../components/EditorField';
import { useProfile } from '../../api/hooks/profile';
// import { handleAddVariable } from "../../components/DocumentPreview/TratoFormat/Elements";
import { TratoFormat, getEditorInstance } from '../DocumentPreview/TratoFormat';
import { useConstant } from '../../hooks/useConstant';
import { useVariables } from '../DocumentPreview/TratoFormat/Elements/VariableElement/useVariables';
import {
  Container,
  Row,
  Col,
  Spinner,
  Card,
  CardBody,
  Button,
  CardFooter,
  CardHeader,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
} from 'reactstrap';
import {
  EditorProvider,
  CHANGED_DATA,
  ADD_TO_CART,
  SET_LAWYER_NEEDED,
  DELETE_CART_ITEM,
  RESTORE_ITEM,
  RESTORE_DOCUMENT_ITEM,
  useEditorState,
  useEditor,
  useEditorActions,
  SET_CHECKOUT_INFO,
  SET_IS_INVOICE_NEEDED,
  SET_EDIT_FIELD,
  ADD_NEW_VARIABLE,
  DRAG_NEW_VARIABLE,
} from '../../context/editor';

import { useForm } from 'react-hook-form';
import LoadingButton from '../../components/LoadingButton';
import { updateTemplate } from '../../api/actions/templates';
import config from '../../config';
import ConfirmationModal from '../ConfirmationModal';
import { Span } from 'slate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleLeft,
  faAngleRight,
  faSearch,
  faSearchMinus,
} from '@fortawesome/free-solid-svg-icons';
import { insertVariable } from '../DocumentPreview/TratoFormat';
import { GetEditor } from '../DocumentPreview/TratoFormat/Elements/BaseElement.js';
import { getDisplayName } from '../../utils';
import ContinueModal from './ContinueModal';
function NewEditor() {
  //reused
  const { t } = useTranslation(['newEditor', 'common']);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [editLines, setEditLines] = useState(true);
  const [editorState, editorDispatch] = useEditor();

  const [currentEditableItem, setCurrentEditableItem] = useState(false);
  const { documentId, status } = useEditorState();

  const auth = useAuthState();

  const toggleIsInvoice = () => {
    editorDispatch({
      type: SET_IS_INVOICE_NEEDED,
      data: { isInvoiceNeeded: !editorState?.checkoutInfo?.isInvoiceNeeded },
    });
  };
  //HANDLE PAYMENT
  const [isMoral, setIsMoral] = useState(false);
  const { register, watch, errors: errorRQ } = useForm({ mode: 'onBlur' });
  const stripe = useStripe();
  const { publicTemplateId, templateId } = useParams();
  const [hasTemplate, setHasTemplate] = useState(true);
  const createTemplate = ({ templateId, document, tenantId }) => {
    let url = `/templates/${templateId}/buy`;

    return {
      method: 'POST',
      endpoint: url,
      prefix: ' ',
      headers: {
        'Content-Type': 'application/json',
      },
      body: { ...document, tenantId },
    };
  };
  const handlePurchase = async (result) => {
    let itemsT = [];
    let newDocumentId = publicTemplateId ? 'public-template' : 'template';

    if (
      !can('EDIT_TEMPLATE') &&
      editorState?.carrito.filter(
        (x) => x._id !== -1 && x.producto !== 'Plantilla Premium'
      ).length > 0
    )
      itemsT.push({
        price: 'edit_element_mx',
        quantity: 1,
      });
    if (editorState?.carrito.filter((x) => x._id === -1).length > 0)
      itemsT.push({
        price: 'lawyer_approval_mx',
        quantity: editorState?.carrito.filter((x) => x._id === -1).length,
      });
    if (
      editorState?.mode === 'public-template' &&
      editorState?.publicTemplate?.stripeId &&
      editorState?.publicTemplate?.stripeInfo?.id &&
      !editorState?.publicTemplate?.userTemplate?._id
    )
      itemsT.push({
        price: editorState?.publicTemplate?.stripeInfo?.id,
        quantity: 1,
      });

    await stripe.redirectToCheckout({
      successUrl: `${config.baseUrl}/checkout/success?productName=Edicion De Plantilla`,
      //cancelUrl: `${config.baseUrl}/documents/${editorState?.documentId}/edit`,
      cancelUrl: `${config.baseUrl}/${newDocumentId}s/${editorState.documentId}/edit`,

      mode: 'payment',
      lineItems: [...itemsT],
      clientReferenceId: `template-${result}`,
      customerEmail: profile.email,
    });
  };
  const { mutate: mutateRecover } = useMutation(
    (payload) => fetcher(createTemplate(payload)),
    {
      onSuccess: (result) => {
        handlePurchase(result.templateId);
      },
    }
  );
  const handlePayment = () => {
    const email = watch('email');
    const rfc = watch('rfc');

    editorDispatch({
      type: SET_CHECKOUT_INFO,
      data: {
        isLawyerNeeded: editorState?.checkoutInfo?.isLawyerNeeded,
        invoiceRFC: rfc,
        invoiceEmail: email,
        isInvoiceNeeded: editorState?.checkoutInfo?.isInvoiceNeeded,
        isMoral: isMoral,
        paymentTotal: editorState?.carrito
          .map((x) => x?.importe)
          .reduce((acc, score) => acc + score, 0),
      },
    });

    if (!auth.hasAccount) {
      return auth.openAuthModal({ type: 'signup' });
    } else {
      mutateRecover({
        templateId: documentId,
        document: editorState?.document,
        tenantId: profile.organization,
      });
    }
  };
  const deleteItem = (id, index) => {
    // toast.error(t("templateEdition.deleteModal"), {
    //   position: "top-right",
    // });

    editorDispatch({ type: RESTORE_ITEM, data: { id, index } });
  };

  //HANDLE PAYMENT
  const toggleIsLawyer = () => {
    if (!editorState?.checkoutInfo?.isLawyerNeeded) {
      editorDispatch({
        type: ADD_TO_CART,
        data: {
          producto: 'Revisión de abogado',
          importe: 250,
          _id: -1,
          index: -1,
        },
      });
    } else if (editorState?.checkoutInfo?.isLawyerNeeded) {
      deleteItem(-1, -1);
    }
    editorDispatch({
      type: SET_LAWYER_NEEDED,
      data: { isLawyerNeeded: !editorState?.checkoutInfo?.isLawyerNeeded },
    });
  };
  const { checkMissingSignatures, setCurrentElement } = useEditorActions();

  const restoreCart = (id, index) => {
    editorDispatch({ type: DELETE_CART_ITEM, data: { id, index } });
  };
  const restoreItem = (id, index) => {
    // setCurrentEditableItem(false);
    // toast.error(t("templateEdition.deleteModal"), {
    //   position: "top-right",
    // });
    editorDispatch({ type: RESTORE_DOCUMENT_ITEM, data: { id, index } });
  };
  //added
  const [newCart, setNewCart] = useState([]);
  const [isEdited, setIsEdited] = useState(false);
  const { profile, can } = useProfile();
  const [choosenParticipant, setChoosenParticipant] = useState(1);

  function scrollTo(id) {
    const currentElement = document.getElementById(id);
    const parentElement = document.getElementById(
      'newEditor__sections__container'
    );
    var y = window.scrollY;
    if (currentElement != undefined) {
      // console.log(currentElement.offsetTop);
      // console.log(parentElement.offsetTop);
      //console.log(y);
      if (y >= 700) {
        parentElement.scrollTop = currentElement.offsetTop - 400;
      } else if (y < 700) {
        currentElement.scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest',
        });
      }
    }
  }
  function scrollToContract(id) {
    if (id != undefined) {
      const currentContractElement = document.querySelectorAll(
        'div[data-element-id=' + '"' + `${id}` + '"' + ']'
      );

      setTimeout(() => {
        currentContractElement[0].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      });
    }
  }

  useEffect(() => {
    scrollTo(editorState?.currentElement?._id);
    //console.log({
    //   templateId: documentId,
    //   elements: editorState.document.elements,
    // });
    // console.log(editorState);
    //console.log(newCart);
  }, [editorState?.currentElement?._id]);

  const deleteDocEdition = () => {
    setNewCart(newCart.filter((item) => item.name !== 'Edición de Documento'));
  };
  useEffect(() => {
    if (editorState.carrito.length > 0) {
      editorState.carrito.map((item) => {
        if (item.producto === 'Plantilla Premium') {
          setNewCart([
            ...newCart,
            {
              name: 'Plantilla Premium',
              importe: item.importe,
            },
          ]);
        }
      });
    }
  }, [hasTemplate]);

  useEffect(() => {
    if (isEdited) {
      setNewCart([
        ...newCart,
        {
          name: 'Edición de Documento',
          importe: !can('EDIT_TEMPLATE') ? 800 : 0,
        },
      ]);
    }

    if (!isEdited) {
      deleteDocEdition();
    }
  }, [isEdited]);

  useEffect(() => {
    if (editorState?.checkoutInfo?.isLawyerNeeded) {
      setNewCart([
        ...newCart,
        {
          name: 'Revisión del abogado',
          importe: 250,
        },
      ]);
    }
    if (editorState?.checkoutInfo?.isLawyerNeeded === false) {
      const selectItem2 = 'Revisión del abogado';
      const deleteEdition2 = newCart.filter(
        (item) => item.name !== selectItem2
      );
      setNewCart(newCart.filter((item) => item.name !== selectItem2));
      //console.log(deleteEdition2);
    }
  }, [editorState?.checkoutInfo?.isLawyerNeeded]);

  useEffect(() => {
    if (editorState.carrito.length > 0) {
      const length2 = editorState.carrito.filter(
        (e) => e._id != undefined && e._id != -1
      ).length;
      //console.log(length2);
      if (length2 > 0) {
        setIsEdited(true);
      } else {
        setIsEdited(false);
      }
      const length3 = editorState.carrito.filter(
        (e) => e.producto === 'Plantilla Premium'
      ).length;

      if (length3 > 0) {
        setHasTemplate(false);
      } else {
        setHasTemplate(true);
      }
      //console.log(editorState.carrito);
    }
  }, [editorState.carrito]);
  const selectNewItem = (e) => {
    setCurrentElement(e);
    scrollToContract(e._id);
    setCurrentEditableItem(false);
  };

  function restoreDocument() {
    //console.log(editorState?.carrito);

    deleteDocEdition();
    setIsEdited(false);
    if (editorState?.document?.elements != undefined) {
      toast.success(t('toast.restoreDocument'), {
        position: 'top-right',
      });

      // restoreCart
      editorState.carrito.map((item, index) => {
        if (item.producto != 'Plantilla Premium') {
          return restoreCart(item._id, index);
        }
      });
      editorState.document.elements.map((item, index) => {
        return restoreItem(item._id, index);
      });
    }
    setRestoreDocModal(false);
  }

  const { mutate: saveTemplateMutate } = useMutation(
    (payload) => fetcher(updateTemplate(payload)),
    {
      onSuccess: (result) => {
        toast.success(t('toast.save'));
      },
    }
  );

  const handleSaveTemplate = () => {
    saveTemplateMutate({
      templateId: editorState.document._id,
      elements: editorState.document.elements,
    });
  };
  const [variables, setVariables] = useState([]);
  const [participantId, setParticipantId] = useState('');
  const [searchFilter, setSearchFilter] = useState('');
  const [isPayment, setIsPayment] = useState(false);
  const getVariables = () => {
    const Variables = editorState?.document?.elements?.map((element, index) =>
      element?.children
        ?.filter(
          (child) =>
            child.participantId === participantId &&
            child.type === 'variable' &&
            child.value !== undefined &&
            !child.value.includes('<') &&
            child.value.toLowerCase().includes(searchFilter.toLowerCase())

          // <div
          //   className={`variable--participant${child.participantIndex}`}
          //   style={{
          //     padding: "2px",
          //     paddingLeft: "3px",
          //     paddingRight: "3px",
          //     borderRadius: "5px",
          //   }}
          // >
          //   <span>{child.name}</span>
          // </div>
        )
        .map((child) => {
          const newChild = {
            name: child.value,
            value: child.value,
            fontSize: child.fontSize,
            participantIndex: child.participantIndex,
            participantId: child.participantId,
            apiName: child.apiName,
            children: child.children,
            lineHeight: child.lineHeight,
            type: child.type,

            variableType: child.variableType,
            _id: child._id,
          };
          return newChild;
          //           apiName: "p2_nombreComisionista"
          // children: [{…}]
          // fontSize: "12px"
          // lineHeight: "1.5"
          // participantId: "5e83d3d2f7a094b96c7054a3"
          // type: "variable"
          // value: "Nombre comisionista"
          // variableType: "text"
          // _id: "5e8517ea9da6708e91f13889"
        })
    );
    const concatVariables = [].concat.apply([], Variables);
    const filteredVariables = Array.from(
      new Set(concatVariables.map((child) => child.name))
    ).map((id) => {
      return concatVariables.find((child) => child.name === id);
    });
    //console.log(concatVariables);
    setVariables(filteredVariables);
  };
  useEffect(() => {
    const firstParticipant = editorState.participants[0];
    setParticipantId(firstParticipant?._id);
  }, [editorState.participants]);

  useEffect(() => {
    getVariables();
    //console.log(variables);
  }, [choosenParticipant, participantId]);
  useEffect(() => {
    getVariables();
  }, [searchFilter]);

  useEffect(() => {
    editorDispatch({
      type: SET_EDIT_FIELD,
      data: false,
    });
  }, []);
  useEffect(() => {
    // console.log(editorState.carrito);
    const editorFielParent = document.getElementById('originalEditoContainer');
    if (editorFielParent) {
      editorFielParent.hidden = true;
    }
  }, [editorState.currentElement._id]);

  useEffect(() => {
    if (
      newCart.map((x) => x?.importe).reduce((acc, score) => acc + score, 0) > 0
    ) {
      setIsPayment(true);
    }
    if (newCart.length === 0) {
      setIsPayment(false);
    }
  }, [newCart]);

  const handleParticipantClic = (i, id) => {
    setChoosenParticipant(i + 1);
    setParticipantId(id);
    //console.log(id);
  };

  const handleAddVariable = (variable) => {
    if (editorState.editorField === true) {
      editorDispatch({
        type: ADD_NEW_VARIABLE,
        data: variable,
      });
    }
  };
  const handleDragVariable = (variable) => {
    if (editorState.editorField === true) {
      editorDispatch({
        type: DRAG_NEW_VARIABLE,
        data: variable,
      });
    }
  };
  //DeleteModal
  const [restoreDocModal, setRestoreDocModal] = useState(false);
  const participant = useRef();
  const scroll = (scrollOffset) => {
    participant.current.scrollLeft += scrollOffset;
  };
  return (
    <MainLayout
      className="p-0"
      footer={false}
      banner={
        !auth?.accessToken && {
          message: t('actions.newTemplates'),
          icon: 'file',
        }
      }
      showUpgradeBanner={false}
    >
      <ContinueModal
        toggle={isConfirmationOpen}
        handleClose={() => setIsConfirmationOpen(false)}
        handleContinue={handlePayment}
        confirmationText={t('modales.payModal.text')}
        headerText={t('modales.payModal.title')}
        continueButton={t('modales.payModal.button')}
      />
      <ContinueModal
        toggle={restoreDocModal}
        handleClose={() => setRestoreDocModal(false)}
        handleContinue={restoreDocument}
        confirmationText={t('modales.deleteModal.text')}
        headerText={t('modales.deleteModal.title')}
        continueButton={t('modales.deleteModal.button')}
      />
      <div className="new__editor">
        <div className="editor--header">
          <div className="header--box">
            <h1>{t('header.title')}</h1>
            <p>{t('header.subtitle')}</p>
          </div>
        </div>
        <div className="editor--container">
          <div className="editor--grid1">
            <div className="grid1--box__1">
              <div className="newEditor---box__1--header">
                <div className="box__1--header--title">
                  <h4>{t('contractSections.title')}</h4>
                </div>
                <div className="box__1--header--content">
                  <span>{t('contractSections.text.one')}</span>
                  <p>
                    {t('contractSections.text.two')}{' '}
                    {editorState?.document?.elements?.length}{' '}
                    {t('contractSections.text.three')}
                  </p>
                </div>
              </div>
              <div className="grid1--box__1--main__content">
                <div
                  className="child__container"
                  id="newEditor__sections__container"
                >
                  {editorState?.document?.elements?.map((item) => (
                    <SectionChild
                      id={item._id}
                      item={item}
                      handleClick={selectNewItem}
                      activeStep={editorState?.currentElement?._id}
                      text={
                        item?.children?.[0]
                          ? item?.children?.[0]?.text?.length <= 24
                            ? item?.children?.[0]?.text?.slice(0, 24)
                            : item?.children?.[0]?.text?.slice(0, 24) + '...'
                          : ''
                      }
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className="grid1--box__1">
              <div className="newEditor---box__1--header">
                <div className="box__1--header--title">
                  <h4>{t('variables.title')}</h4>
                </div>

                <div
                  className="participant__container"
                  style={{
                    maxWidth: '250px',
                    maxHeight: 80,

                    position: 'relative',
                  }}
                >
                  <div
                    onClick={() => scroll(-200)}
                    className="newEditor_participant_scroll_control"
                    style={{
                      position: 'absolute',
                      left: '-37px',
                      top: '3px',
                      cursor: 'pointer',
                      paddingLeft: '20px',
                      height: '30px',
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faAngleLeft}
                      size={'lg'}
                      color="#a7a7a7"
                    />
                  </div>
                  <div
                    className="participant__overflow"
                    ref={participant}
                    style={{
                      maxWidth: '250px',
                      maxHeight: 80,
                      overflowX: 'scroll',

                      scrollbarWidth: '0px !important',
                      display: 'flex',
                    }}
                  >
                    {editorState.participants.map((participant, i) => (
                      <div
                        onClick={() =>
                          handleParticipantClic(i, participant._id)
                        }
                        style={{
                          fontFamily: 'Lato',
                          fontWeight: 'normal',
                          fontSize: '18px',
                          maxHeight: '60px',
                          marginBottom: '5px',
                          minWidth: `${participant.label.length * 6}`,
                          width: 'fit-content',
                          marginRight: '20px',
                          paddingLeft: '5px',
                          paddingRight: '5px',
                          borderBottom: `${
                            i + 1 === choosenParticipant
                              ? '2px solid #f37b33'
                              : ''
                          }`,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <span
                          className="font-weight-bold"
                          style={{
                            minWidth: `${participant.label.length * 5}`,
                            whiteSpace: 'nowrap',
                            fontSize: '13px',
                            color: `${
                              i + 1 === choosenParticipant ? '#f37b33' : ''
                            }`,
                          }}
                        >
                          {participant.label}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div
                    onClick={() => scroll(200)}
                    className="newEditor_participant_scroll_control"
                    style={{
                      position: 'absolute',

                      right: '-37px',
                      top: '3px',
                      cursor: 'pointer',
                      width: '30px',
                      height: '30px',
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      color="#a7a7a7"
                      size={'lg'}
                    />
                  </div>
                </div>
                <div className="variableSearch">
                  <FontAwesomeIcon
                    icon={faSearch}
                    size="1x"
                    color="#a7a7a7"
                    style={{ position: 'absolute', left: 10, top: 10 }}
                  />
                  <input
                    type="text"
                    onChange={(event) => setSearchFilter(event.target.value)}
                  />
                </div>
              </div>
              <div className="grid1--box__1--main__content  ">
                <div
                  className="child__container variablesContainer"
                  style={{ maxWidth: '92%', paddingLeft: '30px' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexFlow: 'row wrap',
                      gap: '15px',
                    }}
                  >
                    {variables.map((variable) => (
                      <div
                        className={`variable--participant${choosenParticipant}`}
                        id={variable._id}
                        style={{
                          padding: '2px',
                          paddingLeft: '3px',
                          paddingRight: '3px',
                          borderRadius: '5px',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleAddVariable(variable)}
                        draggable={true}
                        onDragStart={(e) => {
                          e.dataTransfer.setData(
                            'text/plain',
                            ' '
                            // `${JSON.stringify(variable)}`
                          );
                          // e.dataTransfer.effectAllowed = "move";
                          // handleAddVariable(variable);
                        }}
                        onDragEnd={(e) => {
                          handleDragVariable(variable);
                        }}
                      >
                        <span>{variable.name}</span>
                      </div>
                    ))}
                    {variables.length === 0 && 'Sin Resultados'}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid1--box__2">
              <div className="newEditor---box__2--header">
                <div className="box__2--header--title">
                  <h4>{t('editionImport.title')}</h4>
                </div>
              </div>
              <div className="grid1--box__2--body">
                <div>
                  <div className="box__2--body--tables">
                    <div className="box__2--body--table__1">
                      <div className="table__1--header">
                        <span>{t('editionImport.tableHeader.one')}</span>
                        <div>
                          <span>{t('editionImport.tableHeader.two')}</span>
                        </div>
                      </div>
                      {editorState?.carrito.map((item) =>
                        item.producto === 'Plantilla Premium' ? (
                          <div
                            className="table__1--row"
                            style={{ marginBottom: '10px' }}
                          >
                            <span className="row--first">
                              {t('editionImport.products.two.name')}
                            </span>
                            <span className="row--second">
                              ${item.importe} MXN
                            </span>
                          </div>
                        ) : (
                          ''
                        )
                      )}
                      {editorState?.carrito.length > 0 && isEdited ? (
                        <div className="table__1--row">
                          <span className="row--first">
                            {t('editionImport.products.one.name')}
                          </span>
                          <span className="row--second">
                            ${!can('EDIT_TEMPLATE') ? 800 : 0} MXN
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="table__1--row">
                        <div>
                          <input
                            type="checkbox"
                            checked={editorState?.checkoutInfo?.isLawyerNeeded}
                            onClick={() => toggleIsLawyer()}
                          />
                          <label htmlFor="" className="row--first">
                            {t('editionImport.products.three.name')}
                          </label>
                        </div>
                        <span className="row--second">$250 MXN</span>
                      </div>
                    </div>
                    <div className="box__2--body--table__2">
                      <div className="column">
                        <span className="row--one">
                          {t('editionImport.total')}
                        </span>
                        <div className="row--two">
                          <span>
                            $
                            {newCart != undefined
                              ? newCart
                                  .map((x) => x?.importe)
                                  .reduce((acc, score) => acc + score, 0)
                              : 0}{' '}
                            MXN
                          </span>
                        </div>
                      </div>
                      <div className="column">
                        <span className="row--three">
                          {t('editionImport.legend')}
                        </span>
                      </div>

                      <div className="column">
                        <div className="row--four">
                          {' '}
                          <input
                            type="checkbox"
                            onClick={toggleIsInvoice}
                            checked={editorState?.checkoutInfo?.isInvoiceNeeded}
                          />
                          <label htmlFor="">
                            {t('editionImport.invoice.title')}
                          </label>
                        </div>
                      </div>
                      {editorState?.checkoutInfo?.isInvoiceNeeded && (
                        <Row className="invoice--form">
                          <FormGroup className="form-group mb-0 ">
                            <Label className="mb-1" for="inputEmail">
                              {t('editionImport.invoice.email')}{' '}
                              <span className="text-accent">*</span>
                            </Label>
                            <InputGroup>
                              <Input
                                type="email"
                                name="email"
                                id="inputEmail"
                                invalid={errorRQ.email}
                                innerRef={register({
                                  required: t(
                                    'editionImport.invoice.validemail'
                                  ),
                                  pattern: {
                                    value:
                                      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                    message: t(
                                      'editionImport.invoice.validemail'
                                    ),
                                  },
                                })}
                                placeholder={t('editionImport.invoice.email')}
                              />
                              <FormFeedback>
                                {' '}
                                {errorRQ?.email?.message}{' '}
                              </FormFeedback>
                            </InputGroup>
                          </FormGroup>

                          <FormGroup className="form-group mb-0">
                            <Label className="mb-1" for="inputEmail">
                              {t('RFC')} <span className="text-accent">*</span>
                            </Label>
                            <InputGroup>
                              <Input
                                bsSize="md"
                                type="rfc"
                                name="rfc"
                                id="rfc"
                                invalid={errorRQ.rfc}
                                innerRef={register({
                                  required: true,
                                  maxLength: 13,
                                  minLength: 12,
                                })}
                                placeholder={'RFC'}
                              />
                              <FormFeedback>
                                {' '}
                                {t('editionImport.invoice.validRFC')}{' '}
                              </FormFeedback>
                            </InputGroup>
                          </FormGroup>

                          <FormGroup className="form-group mb-0 lastInput">
                            <InputGroup>
                              <input
                                type="checkbox"
                                className="mr-0"
                                name="isMoral"
                                onClick={() => setIsMoral(!isMoral)}
                                checked={isMoral}
                              />
                            </InputGroup>
                            <Label className="mb-1" for="isMoral">
                              {t('editionImport.invoice.isJuridicalPerson')}{' '}
                            </Label>
                          </FormGroup>
                        </Row>
                      )}
                    </div>

                    <div className="box__2--body--buttons">
                      <button
                        className="button--one"
                        disabled={!isPayment}
                        style={
                          !isPayment ? { opacity: '.7', cursor: 'pointer' } : {}
                        }
                        onClick={() => setIsConfirmationOpen(true)}
                      >
                        {t('editionImport.buttons.one')}
                      </button>
                    </div>
                  </div>
                </div>

                <button
                  className="button--two"
                  onClick={() => setRestoreDocModal(true)}
                  style={!isEdited ? { opacity: '0.7', cursor: 'pointer' } : {}}
                  disabled={!isEdited}
                >
                  {t('editionImport.buttons.two')}
                </button>
              </div>
            </div>
          </div>
          <div className="editor--grid2">
            <div
              className={
                editLines ? 'grid2--editor editLinesActive' : 'grid2--editor'
              }
            >
              <div className="grid2--header">
                <div className="header--box--one">
                  <input
                    type="checkbox"
                    defaultChecked={editLines}
                    onClick={() => setEditLines(!editLines)}
                  />
                  <label htmlFor="">{t('editorContainer.text')}</label>
                </div>
                <div className="header--buttons">
                  <button
                    className="button--one"
                    disabled={!isEdited}
                    style={
                      !isEdited ? { opacity: '0.6', cursor: 'pointer' } : {}
                    }
                    onClick={() => setRestoreDocModal(true)}
                  >
                    {t('editorContainer.button2')}
                  </button>
                  {can('EDIT_TEMPLATE') && hasTemplate ? (
                    <button
                      className="button--two"
                      onClick={handleSaveTemplate}
                    >
                      {t('editorContainer.button1')}
                    </button>
                  ) : (
                    ''
                  )}
                </div>
              </div>

              <EditorDocumentPreview card header={true} />
            </div>
          </div>
        </div>
      </div>
      <div className="newEditor__ResponsiveView">
        <EditorDocumentPreview card header={true} />
      </div>
      {
        <div
          id="originalEditoContainer"
          className="__web-inspector-hide-shortcut__"
          style={{
            width: 1,
            height: 1,
            overflow: 'hidden',
            visibility: 'hidden !important',
          }}
        >
          <div id="editor--to--insert">
            <EditTemplateConfiguration />
          </div>
        </div>
      }
    </MainLayout>
  );
}

export default NewEditor;
